<script setup lang="ts">
import PumpQcReports from '@/components/pump_reports/PumpQcReports.vue';

</script>

<template>
  <PumpQcReports />
</template>

<style scoped lang="scss">
</style>
